import { render, staticRenderFns } from "./TakipTalebiForm.vue?vue&type=template&id=f68b66e6"
import script from "./TakipTalebiForm.vue?vue&type=script&lang=ts"
export * from "./TakipTalebiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports